module.exports = "/_next/static/images/question-d2d55b835e09db3afe381ceb9021f964.svg";